import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Grid, Text } from '@chakra-ui/react';
import { TableRow } from '../TableRow';
const TableGroupedRowFC = ({ rowId, row, isReadOnly, columns, errors, noBg, onValueChange }) => {
    const isTableWithStickyColumn = columns[0]?.sticky || columns[columns.length - 1]?.sticky;
    return (_jsxs(Grid, { gridColumn: `1/-1`, gridTemplateColumns: `subgrid`, children: [_jsx(Box, { p: rowId === 0 ? '4px 2px 2px' : '2px', borderColor: "border", gridColumn: "1/-1", position: "sticky", top: 0, sx: isTableWithStickyColumn
                    ? {
                        borderTop: '1px solid',
                        borderBottom: '1px solid',
                        borderColor: 'border'
                    }
                    : {}, children: _jsx(Text, { width: 'max-content', position: "sticky", left: 0, fontSize: "14px", fontWeight: 500, children: row.name }) }), row.items.map((subRow, id) => {
                return (_jsx(TableRow, { rowId: id, row: subRow, columns: columns, isReadOnly: !!isReadOnly, errors: errors, noBg: noBg, onValueChange: onValueChange }, subRow.key ?? id));
            })] }));
};
export const TableGroupedRow = memo(TableGroupedRowFC);
//# sourceMappingURL=TableGroupedRow.js.map